(() => {
  function showError(form, message) {
    const error = form.querySelector('[data-form-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    error.focus();
  }
  function clearError(form) {
    const error = form.querySelector('[data-form-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
  }
  function responseError(data) {
    if (typeof data.description === 'string') return data.description;
    if (typeof data.message === 'string') return data.message;
    if (typeof data.errors === 'string') return data.errors;
    if (data.errors && typeof data.errors === 'object') return Object.values(data.errors).flat().join(' ');
    return 'This request could not be completed. Review your selection and try again.';
  }
  async function submitCartRequest(form, button, destination) {
    if (form.dataset.submitting) return;
    clearError(form);
    const body = new FormData(form);
    const action = new URL(form.action, window.location.href);
    action.pathname += form.matches('[data-cart-form]') ? '/update.js' : '.js';
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    const states = buttons.map(item => item.disabled);
    buttons.forEach(item => { item.disabled = true; });
    const selector = form.querySelector('[data-variant-select]');
    if (selector) selector.disabled = true;
    const oldLabel = button && button.textContent;
    if (button) button.textContent = 'Please wait…';
    try {
      const response = await fetch(action.href, { method: 'POST', body, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        showError(form, responseError(data));
        return;
      }
      window.location.assign(destination);
    } catch (error) {
      showError(form, 'We could not confirm the update. Check your shopping bag before trying again, or reload this page.');
    } finally {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      if (selector) selector.disabled = false;
      buttons.forEach((item, index) => { item.disabled = states[index]; });
      if (button) button.textContent = oldLabel;
    }
  }
  function initialize(root) {
    const sections = Array.from(root.querySelectorAll('[data-product-section]'));
    if (root.matches && root.matches('[data-product-section]')) sections.unshift(root);
    sections.forEach(section => {
      if (section.dataset.variantReady) return;
      section.dataset.variantReady = 'true';
      const form = section.querySelector('.p-product-form');
      const select = section.querySelector('[data-variant-select]');
      const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
      const button = section.querySelector('[data-add-button]');
      const update = (changeURL = true) => {
        const id = select ? select.value : form.querySelector('[name="id"]').value;
        const variant = variants.find(item => String(item.id) === id);
        if (!variant) return;
        clearError(form);
        section.querySelector('[data-product-price]').textContent = variant.price;
        const compare = section.querySelector('[data-product-compare]');
        if (compare) { compare.hidden = !variant.compare; compare.textContent = variant.compare || ''; }
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
        section.querySelector('[data-variant-status]').textContent = variant.available ? '' : 'This selection is currently sold out.';
        const quantity = section.querySelector('[data-product-quantity]');
        const previous = Number(quantity.value);
        quantity.min = variant.min;
        quantity.step = variant.increment;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        let next = Math.max(variant.min, previous || variant.min);
        next = variant.min + Math.floor((next - variant.min) / variant.increment) * variant.increment;
        if (variant.max) next = Math.min(next, variant.max);
        quantity.value = next;
        const accelerated = form.querySelector('.shopify-payment-button');
        if (accelerated) accelerated.hidden = !variant.available;
        if (variant.media) {
          const gallery = section.querySelector('.p-product-gallery');
          const media = section.querySelector(`[data-media-id="${variant.media}"]`);
          if (gallery && media && gallery.firstElementChild !== media) { gallery.prepend(media); gallery.scrollLeft = 0; }
        }
        if (changeURL) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      };
      if (select) select.addEventListener('change', () => update());
      update(false);
      form.addEventListener('submit', event => {
        // Shopify accelerated checkout owns its own payment integration.
        if (event.submitter && event.submitter !== button) return;
        event.preventDefault();
        if (!button.disabled) submitCartRequest(form, button, section.dataset.cartUrl);
      });
    });
    root.querySelectorAll('[data-cart-form]').forEach(form => {
      if (form.dataset.cartReady) return;
      form.dataset.cartReady = 'true';
      const quantities = Array.from(form.querySelectorAll('[data-cart-quantity]'));
      const validate = input => {
        const value = Number(input.value);
        const min = Number(input.dataset.minimum) || 1;
        input.setCustomValidity(value > 0 && value < min ? `Choose at least ${min}, or enter 0 to remove this item.` : '');
      };
      quantities.forEach(input => { input.addEventListener('input', () => validate(input)); validate(input); });
      form.addEventListener('submit', event => {
        if (!event.submitter || event.submitter.name !== 'update') return;
        event.preventDefault();
        submitCartRequest(form, event.submitter, form.action);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
